import React, { useEffect, useState } from 'react';
import { FilterChoice } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FilterChoice';
import Hotel from '@app/model/hotel/Hotel';
import SearchHotelsFilterInput from '@app/model/flexi_sets/input/SearchHotelsFilterInput';
import _isEmpty from 'lodash/isEmpty';
import FlexiSetFilterWrapper
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetFilterWrapper';
import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';

export type FlexiSetGenericFilterFilterConfig = {
	title: string;
	choices: FilterChoice<any>[];
	getHotelValue: (hotel: SearchHotelWithinRadiusResult) => number | undefined;
	addToFilter: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => void;
	removeFromFilter: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => void;
	isChoiceSelected: (filter: SearchHotelsFilterInput, choice: FilterChoice<any>) => boolean;
};

const FlexiSetGenericFilterFragment: React.FunctionComponent<{
	areaHotels: SearchHotelWithinRadiusResult[],
	filter: SearchHotelsFilterInput,
	onFilter: (filter: SearchHotelsFilterInput) => void,
	config: FlexiSetGenericFilterFilterConfig
}> = ({ areaHotels, filter, onFilter, config }) => {

	const [choices, setChoices] = useState<FilterChoice<number>[]>([]);

	useEffect(() => {
		const choicesWithCounts: FilterChoice<number>[] = config.choices.map(choice => ({
			...choice,
			count: 0
		}));

		if (!_isEmpty(areaHotels)) {
			areaHotels.forEach(hotel => {
				const value = config.getHotelValue(hotel);
				if (!!value) {
					const choiceIndex = choicesWithCounts.findIndex(choice => (choice.mode === 'EQUALS' && choice.value === value) || (choice.mode === 'MORE_THAN' && value >= choice.value));
					if (choiceIndex !== -1) {
						choicesWithCounts[choiceIndex].count++;
					}
				}
			});
		}
		setChoices(choicesWithCounts);
	}, [areaHotels, config]);

	const onChecked = (e: React.ChangeEvent<HTMLInputElement>, choice: FilterChoice<number>) => {
		if (e.target.checked) {
			config.addToFilter(filter, choice);
		} else {
			config.removeFromFilter(filter, choice);
		}
		onFilter(filter);
	};

	return <FlexiSetFilterWrapper title={config.title}>
		<ul className="space-y-1 text-sm text-gray-600">
			{choices.map((choice, index) => <li key={choice.name}>
				<div className="flex items-center gap-x-2">
					<input 
						type="checkbox" 
						id={`checkbox_${config.title}_${choice.value}`} 
						onChange={(e) => onChecked(e, choice)}
						className="input-checkbox cursor-pointer" 
						checked={config.isChoiceSelected(filter, choice)}
					/>
					<label 
						htmlFor={`checkbox_${config.title}_${choice.value}`}
						className="block text-sm font-normal leading-6 text-gray-700 cursor-pointer"
					>
						{choice.name}
					</label>
					<span
						className="inline-flex items-center rounded-md bg-slate-100 px-1.5 py-0.5 text-xs font-medium text-slate-700">
						{choice.count}
					</span>
				</div>
			</li>)}
		</ul>
	</FlexiSetFilterWrapper>;
};

export default FlexiSetGenericFilterFragment;
